import React from 'react';

const TotalRejectedIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 5H21M13 12H21M8 19H21M8.5 9.5L3.5 14.5M3.5 9.5L8.5 14.5'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TotalRejectedIcon;
